import React from 'react';

const CrossSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M18.3 5L12 11.3 5.7 5l-.7.7 6.3 6.3L5 18.3l.7.7 6.3-6.3 6.3 6.3.7-.7-6.3-6.3L19 5.7z"
        />
    </svg>
);

CrossSvg.displayName = 'CrossSvg';
export default CrossSvg;
